import Swiper from 'swiper';
import { Navigation, Zoom } from 'swiper/modules';

let initialViewport;

// Use event delegation on document so the listener survives dynamic DOM replacements
// (e.g. after variant switches on the modell page trigger an AJAX reload)
document.addEventListener('click', (e) => {
  const opener = e.target.closest('.js_full_picture_opener');
  if (opener) {
    execFullPictureClick(opener.dataset.images.split(','), Number(opener.dataset.key));
  }
});

/**
 * @param {string[]} pictureUrls
 * @param {number} index
 */
export function execFullPictureClick(pictureUrls, index) {
  let pictureHtml = '';
  for (let i = 0; i < pictureUrls.length; i++) {
    // The .swiper-zoom-container wrapper is what the Swiper Zoom module pinch-/double-tap-zooms.
    pictureHtml +=
      '<div class="swiper-slide"><div class="swiper-zoom-container">' +
      '<img src="' +
      pictureUrls[i] +
      '" alt="Großes Bild" class="zoom_image"></div></div>';
  }

  $('#js-zoom-swiper-slider').html(pictureHtml);
  showZoomPopup();
  initFullPictureSlider(index);
}

function showZoomPopup() {
  window.showPopup(false, 'js-full-picture-zoom');

  const viewportElement = document.querySelector('meta[name="viewport"]');
  initialViewport = viewportElement.content;
  viewportElement.content = 'width=device-width, initial-scale=1, maximum-scale=6, minimum-scale=1, user-scalable=yes';
}

/**
 * @param {number} index
 */
function initFullPictureSlider(index) {
  const zoomContainer = document.getElementById('js-zoom-swiper-slider-container');
  if (!zoomContainer) {
    return;
  }
  new Swiper(zoomContainer, {
    modules: [Navigation, Zoom],
    slidesPerView: 1,
    spaceBetween: 32,
    initialSlide: index,
    loop: true,
    zoom: {
      maxRatio: 4,
    },
    navigation: {
      nextEl: zoomContainer.querySelector('.swiper-button-next'),
      prevEl: zoomContainer.querySelector('.swiper-button-prev'),
      addIcons: false,
    },
  });
}
